import React from 'react';
import { Typography } from 'antd';
import ReactMarkdown from 'react-markdown';
import { AnalysisResult, AnalysisStatus } from '../../../types';
import './markdown.css';

const { Title, Text } = Typography;

interface MarketInsightsProps {
  results: AnalysisResult;
  status: AnalysisStatus;
  }

const MarketInsights: React.FC<MarketInsightsProps> = ({ results, status }) => {
  const { market_insights } = results;

  if (status === 'error') {
    return <Text>There was an unexpected error with market insights, once the report is complete, please rerun the analysis.</Text>;
  } else if (status === 'skipped') {
    return <Text>Market insights were skipped by the user.</Text>;
  }

  if (!market_insights) {
    return <Text>No market insights data available.</Text>;
  }

  const content = market_insights.cleaned_content;

  return (
    <div style={{ marginBottom: '64px' }}>
      {content ? (
        <div className="markdown-content">
          <ReactMarkdown>{content}</ReactMarkdown>
        </div>
      ) : (
        <Text type="secondary">Analysis in progress...</Text>
      )}
    </div>
  );
};

export default MarketInsights;